// const preventDefault = (e) => {
//   e.preventDefault || e.preventDefault();
//   e.stopPropagation || e.stopPropagation();
  
//   return false;
// };

let lastOverflow = '';

const disableScroll = () => {
  // window.addEventListener('scroll', preventDefault);

  const bodyNode = document.getElementsByTagName('body')[0];
  lastOverflow = bodyNode.style.overflow;
  bodyNode.style.overflow = 'hidden';
};

const enableScroll = () => {
  // window.removeEventListener('scroll', preventDefault);

  const bodyNode = document.getElementsByTagName('body')[0];
  bodyNode.style.overflow = lastOverflow;
};


export default {
  disableScroll,
  enableScroll,
}